// EventForm.tsx
import React, { useState, useEffect } from 'react';
import {
    Box,
    TextField,
    Typography,
    Stack,
    CircularProgress,
    Button,
} from '@mui/material';
import { EventImage, EventRecord } from '../../../types/event';
import { useFetch } from '../../../hooks/useFetch';
import { api, OriginImage } from '../../../api/originApi';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../../tools/util';

export interface SnapshotFormProps {
    origin_id: number;
    onCancel: () => void;
}

const SnapshotForm: React.FC<SnapshotFormProps> = ({
    origin_id,
    onCancel,
}) => {
    const { t } = useTranslation();
    const title = t('SnapshotForm.title');

    const { data, error, loading, } = useFetch<OriginImage>(api.getSnapshot, { 
        image: '', 
        result: false,
      }, {
        origin_id
      }
    );

    console.log('loading',loading,'data',data);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress />
            </Box>
        );
    }
    if (!data) {
        return <Typography color="info">{t('no data')}</Typography>;
    }
    
    if (error) {
        return <Typography color="error">{t('EventForm.error')}: {error.message}</Typography>;
    }

    const hasBackground = data && typeof data.image === 'string' && data.image.trim() !== '';
    const backgroundSrc = hasBackground ? `data:image/jpeg;base64,${data.image}` : '';

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>

      <Stack spacing={3} sx={{ mb: 3 }}>
      <img 
        src={backgroundSrc} 
        alt="Сгенерированный фон" 
        style={{ maxWidth: '100%', height: 'auto' }}
      />

      </Stack>
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onCancel} sx={{ mr: 1 }} 
          variant='outlined'>
            {t('OriginForm.Cancel')}
          </Button>
        </Box>
      </Box>
      
    </Box>
  );
};

export default SnapshotForm;